import { VISION_URL_REGISTRATION_STORAGE_KEY } from '../const/visionUrlRegistrationStorageKey.const'

const REGISTERED_VALUE = '1'

export const hasVisionUrlRegistrationGuard = (): boolean => {
  if (typeof sessionStorage === 'undefined') {
    return false
  }

  try {
    return sessionStorage.getItem(VISION_URL_REGISTRATION_STORAGE_KEY) === REGISTERED_VALUE
  } catch {
    return false
  }
}

export const markVisionUrlRegistered = (): void => {
  if (typeof sessionStorage === 'undefined') {
    return
  }

  try {
    sessionStorage.setItem(VISION_URL_REGISTRATION_STORAGE_KEY, REGISTERED_VALUE)
  } catch {
    // sessionStorage may be unavailable in restricted browser contexts
  }
}
